import React from "react";
import QRCode from "react-qr-code";
import { Button } from "@letsbit/milkylb";
import { FormattedMessage, useIntl } from "react-intl";
import { IonSkeletonText } from "@ionic/react";
import {
  DEPOSIT_ADDRESS_STATE,
  OPERATIONS_VALUES,
  TIME_PERIOD_VALUES,
} from "@letsbit/malcolmlb";

import { ReactComponent as CopyIcon } from "assets/images/icons/copy-purple.svg";
import { Limits } from "components/Limits";
import DepositMessages from "../DepositMessages";

import { CryptoQrCardProps } from "./types";
import { messages } from "./messages";

// import variables from "./Qrcard.vars.module.scss";
import "./styles.scss";

export const CryptoQrCard: React.FC<CryptoQrCardProps> = ({
  depositAddress,
  currency,
  currencyNetworkSelected,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className="flex w-full flex-row items-start gap-2">
      {!depositAddress.data.tag &&
        (depositAddress.data.state === DEPOSIT_ADDRESS_STATE.CREATED ? (
          <QRCode
            size={220}
            value={depositAddress.data?.address}
            className="shrink-0 p-2 opacity-50"
          />
        ) : (
          <IonSkeletonText
            animated
            className="h-[230px] w-[230px] rounded-lg"
          />
        ))}
      <div className="flex w-full flex-col overflow-hidden">
        <h3 className="text-lg text-[--color-neutral-0]">
          <FormattedMessage
            {...messages.yourAddress}
            values={{
              ticker: currency?.ticker_id.toUpperCase(),
              network: currencyNetworkSelected?.payment_network.name,
            }}
          />
        </h3>
        {depositAddress.data.state === DEPOSIT_ADDRESS_STATE.CREATED ? (
          <div className="flex w-full flex-row flex-wrap items-center gap-x-2 overflow-hidden">
            <h2 className="w-4/5 text-wrap break-words font-['Tomato_Grotesk'] text-4xl font-medium text-[--milkylb-color-neutral-400]">
              {depositAddress.data?.address}
            </h2>
            <Button
              type="button"
              fill="clear"
              leftIcon={() => <CopyIcon width={16} height={16} />}
              onClick={() =>
                navigator.clipboard.writeText(
                  depositAddress.data?.address || "",
                )
              }
              className="letsbit-ui-button-outline-svg-filled w-1/5"
            >
              {formatMessage(messages.copy)}
            </Button>
          </div>
        ) : (
          <IonSkeletonText
            animated
            className="mb-8 h-10 w-[500px] rounded-lg"
          />
        )}
        {depositAddress.data.tag &&
          (depositAddress.data.state === DEPOSIT_ADDRESS_STATE.CREATED ? (
            <>
              <h3 className="text-lg text-[--color-neutral-0]">
                <FormattedMessage {...messages.memo} />
              </h3>
              <div className="flex flex-row flex-wrap items-center gap-x-2 overflow-hidden">
                <h2 className="text-wrap font-['Tomato_Grotesk'] text-4xl font-medium text-[--milkylb-color-neutral-400]">
                  {depositAddress.data.tag}
                </h2>
                <Button
                  type="button"
                  fill="clear"
                  leftIcon={() => <CopyIcon width={16} height={16} />}
                  onClick={() =>
                    navigator.clipboard.writeText(depositAddress.data.tag || "")
                  }
                  className="deposit__button letsbit-ui-button-outline-svg-filled ml-6"
                >
                  {formatMessage(messages.copy)}
                </Button>
              </div>
            </>
          ) : (
            <IonSkeletonText
              animated
              className="mb-8 h-10 w-[320px] rounded-lg"
            />
          ))}
        {currency && currencyNetworkSelected && (
          <Limits
            limitParams={{
              currency: currency.id,
              payment_network: currencyNetworkSelected.payment_network.id,
              operation: OPERATIONS_VALUES.DEPOSIT,
            }}
            period={TIME_PERIOD_VALUES.MONTHLY}
            classname="mt-4 w-[400px]"
          />
        )}
        {currency && currencyNetworkSelected && (
          <DepositMessages
            currency={currency}
            currency_network={currencyNetworkSelected}
          />
        )}
      </div>
    </div>
  );
};

export default CryptoQrCard;
